<div class="pa-links">
    <a *ngFor="let item of message.data.responseItemData.links" [href]="item.link" class="pa-link"
       target="_{{message.data.responseItemData.target}}">{{item.label}}</a>
</div>
